import React from 'react';
import classNames from 'classnames';
export default class QuestionHead extends React.Component {


  render() {

    // let text = document.createElement('div');
    // text.innerHTML = this.props.text;
    // text = text.textContent.substr(0,50);
    let status = 'wait';

    //TODO UNCOMENT IT LATER
    // switch (this.props.status){
    //   case 'question_completed':
    //     status = 'completed';
    //     break;
    //   case 'question_failed':
    //     status = 'wrong';
    //     break;
    // }



    return (
      <div className={classNames(`question-accordion-head ${status}`)}>
        <div className="question-accordion-head-inner">
      <span className={classNames('question-accordion-head-icon',
                        {'ic-wait-answer-ico': true}) } />
          <div className="question-accordion-caption">
            <p className="question-accordion-label">QUESTION {this.props.number + 1}</p>
          </div>
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/providers/online_workshop_details/question/QuestionHead.jsx